export default {
  title: {
    en: 'Please verify',
  },
  text: {
    en: `
      By clicking on the "Confirm" button, you agree that you are using
      the special offer and will receive a free perfume with your next
      shipment. Thank you for staying with us!
    `,
  },
  buttonTitle: {
    primary: {
      en: 'Confirm',
    },
    ordinary: {
      en: 'Cancel',
    },
  },
}
